import { render, staticRenderFns } from "./configure-type.vue?vue&type=template&id=df2b7540&scoped=true&"
import script from "./configure-type.vue?vue&type=script&lang=ts&"
export * from "./configure-type.vue?vue&type=script&lang=ts&"
import style0 from "./configure-type.vue?vue&type=style&index=0&id=df2b7540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2b7540",
  null
  
)

export default component.exports